var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google-play_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.323 31.639H4.277c-2.139 0-3.881-1.753-3.881-3.886V4.432A3.895 3.895 0 014.276.546h97.047a3.895 3.895 0 013.881 3.886v23.321a3.895 3.895 0 01-3.881 3.886z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.323 1.163a3.272 3.272 0 013.265 3.269v23.321a3.271 3.271 0 01-3.265 3.269H4.277a3.271 3.271 0 01-3.265-3.269V4.432a3.271 3.271 0 013.265-3.269h97.046zm0-.617H4.277C2.138.546.396 2.3.396 4.432v23.321a3.895 3.895 0 003.88 3.886h97.047a3.895 3.895 0 003.881-3.886V4.432a3.89 3.89 0 00-3.881-3.886z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.293 17.454c-1.83 0-3.318 1.392-3.318 3.304 0 1.903 1.487 3.304 3.318 3.304 1.83 0 3.317-1.401 3.317-3.304 0-1.921-1.487-3.304-3.317-3.304zm0 5.304c-1.004 0-1.866-.828-1.866-2 0-1.19.862-2 1.866-2 1.003 0 1.865.81 1.865 2 0 1.172-.862 2-1.865 2zm-7.234-5.304c-1.83 0-3.317 1.392-3.317 3.304 0 1.903 1.487 3.304 3.317 3.304s3.318-1.401 3.318-3.304c0-1.921-1.488-3.304-3.318-3.304zm0 5.304c-1.003 0-1.865-.828-1.865-2 0-1.19.862-2 1.865-2 1.003 0 1.866.81 1.866 2 0 1.172-.863 2-1.866 2zm-8.597-4.291v1.4h3.352c-.096.794-.36 1.366-.765 1.763-.484.485-1.25 1.03-2.587 1.03-2.069 0-3.679-1.664-3.679-3.735 0-2.07 1.61-3.736 3.678-3.736 1.118 0 1.928.44 2.526 1.005l.986-.987c-.836-.802-1.954-1.418-3.511-1.418-2.825 0-5.201 2.308-5.201 5.136 0 2.828 2.376 5.137 5.2 5.137 1.523 0 2.676-.503 3.582-1.437.924-.925 1.215-2.229 1.215-3.277 0-.326-.027-.626-.08-.872h-4.716v-.01zm35.173 1.084c-.273-.74-1.109-2.106-2.825-2.106-1.698 0-3.115 1.34-3.115 3.304 0 1.85 1.4 3.304 3.274 3.304 1.513 0 2.385-.925 2.754-1.463l-1.126-.749c-.379.555-.889.917-1.628.917-.74 0-1.267-.335-1.602-1.005l4.418-1.832-.15-.37zm-4.497 1.11c-.035-1.278.986-1.93 1.725-1.93.572 0 1.065.291 1.223.705l-2.948 1.225zm-3.59 3.198H66v-9.718h-1.452v9.718zm-2.376-5.665h-.053c-.325-.388-.95-.74-1.742-.74-1.655 0-3.168 1.453-3.168 3.321 0 1.85 1.513 3.296 3.168 3.296.792 0 1.416-.353 1.742-.75h.053v.467c0 1.27-.678 1.939-1.76 1.939-.889 0-1.434-.634-1.663-1.18l-1.268.528c.361.872 1.33 1.956 2.93 1.956 1.7 0 3.142-1.005 3.142-3.445v-5.938h-1.372v.546h-.01zm-1.663 4.564c-1.004 0-1.84-.837-1.84-1.991 0-1.163.837-2.018 1.84-2.018.985 0 1.76.855 1.76 2.018 0 1.154-.775 1.99-1.76 1.99zm18.928-8.617H75.97v9.718h1.452v-3.683h2.024c1.602 0 3.186-1.163 3.186-3.022 0-1.859-1.593-3.013-3.195-3.013zm.036 4.687h-2.06v-3.33h2.06c1.082 0 1.698.898 1.698 1.665 0 .749-.616 1.665-1.698 1.665zm8.95-1.392c-1.048 0-2.139.467-2.588 1.49l1.285.537c.273-.538.783-.714 1.32-.714.748 0 1.514.45 1.522 1.251v.097a3.218 3.218 0 00-1.513-.379c-1.39 0-2.799.767-2.799 2.185 0 1.304 1.135 2.141 2.412 2.141.976 0 1.513-.44 1.847-.951h.053v.748h1.4v-3.727c.008-1.718-1.276-2.678-2.94-2.678zm-.177 5.322c-.475 0-1.135-.238-1.135-.828 0-.75.827-1.04 1.54-1.04.634 0 .933.14 1.32.326a1.751 1.751 0 01-1.725 1.542zm8.22-5.11l-1.664 4.211h-.053l-1.724-4.212h-1.558l2.587 5.886-1.47 3.277h1.514l3.987-9.162h-1.62zm-13.05 6.211h1.451v-9.718h-1.452v9.718z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.492 6.405c-.22.238-.352.608-.352 1.093v17.19c0 .484.132.854.36 1.092l.062.053 9.618-9.63v-.229l-9.627-9.63-.061.061z",
    fill: "url(#google-play_svg__paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.375 19.419l-3.203-3.207v-.23l3.203-3.207.07.044 3.802 2.159c1.082.617 1.082 1.63 0 2.247l-3.802 2.158-.07.036z",
    fill: "url(#google-play_svg__paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.454 19.375l-3.282-3.287-9.68 9.692c.36.379.95.423 1.61.044l11.352-6.45z",
    fill: "url(#google-play_svg__paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.454 12.81L10.111 6.353c-.669-.378-1.259-.334-1.61.044l9.68 9.692 3.273-3.277z",
    fill: "url(#google-play_svg__paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.375 19.304l-11.273 6.414c-.633.361-1.197.335-1.557.009l-.062.061.062.053c.36.326.924.353 1.557-.008l11.343-6.45-.07-.079z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M8.492 25.665c-.23-.238-.361-.608-.361-1.092v.114c0 .485.132.855.36 1.093l.062-.062-.061-.053zM25.247 17.101l-3.872 2.203.07.07 3.802-2.158c.546-.309.81-.714.81-1.12-.036.362-.317.723-.81 1.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M10.111 6.467l15.145 8.617c.493.282.766.643.81 1.004 0-.405-.273-.81-.81-1.119L10.111 6.352c-1.082-.616-1.97-.105-1.97 1.137v.115c0-1.243.88-1.754 1.97-1.137z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.806 10.74V6.16h1.4c.703 0 1.267.211 1.689.634.422.423.634.978.634 1.656 0 .679-.212 1.234-.634 1.657-.422.423-.986.634-1.69.634h-1.399zm.581-.555h.81c.528 0 .95-.15 1.258-.458.308-.3.466-.731.466-1.278 0-.537-.158-.969-.466-1.268-.308-.309-.73-.459-1.258-.459h-.81v3.463zM37.347 10.74V6.16h.59v4.581h-.59zM40.277 10.846c-.334 0-.66-.106-.976-.326a1.511 1.511 0 01-.625-.917l.537-.22c.061.256.193.467.396.635a.981.981 0 00.668.255c.256 0 .476-.07.652-.203a.635.635 0 00.272-.546c0-.255-.088-.45-.272-.59-.185-.141-.467-.264-.863-.388-.405-.123-.713-.29-.924-.493a1.023 1.023 0 01-.317-.776c0-.325.132-.616.388-.854.264-.247.598-.361 1.012-.361.387 0 .704.097.941.29.247.194.405.406.475.635l-.536.22a.796.796 0 00-.282-.405c-.15-.124-.343-.185-.59-.185a.917.917 0 00-.58.185.572.572 0 00-.238.467c0 .167.07.317.22.431.15.115.36.22.651.318.229.07.414.14.563.211.15.07.308.159.458.273.158.115.273.256.352.423.08.167.114.361.114.582 0 .22-.044.422-.14.599a1.038 1.038 0 01-.361.414 1.68 1.68 0 01-.493.229 1.16 1.16 0 01-.502.097zM43.234 10.74h-.59V6.16h1.558c.387 0 .722.132 1.003.387.282.256.423.582.423.978 0 .397-.141.714-.423.978a1.447 1.447 0 01-1.003.388h-.968v1.85zm0-2.414h.986c.246 0 .449-.08.598-.247a.804.804 0 00.22-.546.774.774 0 00-.22-.546c-.15-.168-.343-.247-.598-.247h-.986v1.586zM50.116 10.15c-.449.467-1.012.696-1.68.696-.67 0-1.233-.23-1.682-.696a2.363 2.363 0 01-.677-1.7c0-.67.22-1.234.677-1.701.45-.467 1.012-.696 1.681-.696s1.223.229 1.672.696c.449.467.678 1.03.678 1.692.009.678-.22 1.25-.67 1.709zm-2.922-.38c.343.345.757.512 1.241.512.493 0 .907-.168 1.24-.511.344-.344.511-.784.511-1.313 0-.537-.167-.969-.51-1.313a1.672 1.672 0 00-1.24-.51c-.494 0-.907.167-1.242.51-.334.344-.51.785-.51 1.313.009.529.176.97.51 1.313zM51.62 10.74V6.16h.713l2.227 3.568h.026l-.026-.881V6.159h.59v4.581h-.617L52.21 7.004h-.026l.026.881v2.855h-.59zM56.197 10.74V6.16h.59v4.581h-.59zM57.834 10.74V6.16h1.654c.36 0 .669.114.933.352.255.247.387.537.387.899 0 .22-.053.414-.167.572-.115.168-.264.291-.45.38v.026c.23.079.414.211.555.396.141.185.22.405.22.652 0 .379-.14.687-.413.934-.273.247-.599.37-.977.37h-1.742zm.58-2.617h1.065c.22 0 .396-.07.537-.22a.72.72 0 00.202-.485.674.674 0 00-.193-.475.67.67 0 00-.51-.22h-1.092v1.4h-.009zm0 2.062h1.18c.228 0 .404-.08.545-.238a.757.757 0 00.211-.52.71.71 0 00-.22-.51.73.73 0 00-.572-.239h-1.152v1.507h.008zM61.758 10.74V6.16h.59v4.017h1.98v.564h-2.57zM67.733 6.722h-2.085v1.454h1.883v.546h-1.883v1.454h2.085v.564h-2.675V6.16h2.675v.563zM72.864 6.722h-2.086v1.454h1.883v.546h-1.883v1.454h2.086v.564h-2.675V6.16h2.675v.563zM73.779 10.74V6.16h.713l2.226 3.568h.026l-.026-.881V6.159h.59v4.581h-.616l-2.324-3.736h-.026l.026.881v2.855h-.59z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__paint0_linear",
    x1: 17.319,
    y1: 7.313,
    x2: 4.273,
    y2: 20.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__paint1_linear",
    x1: 26.662,
    y1: 16.09,
    x2: 7.876,
    y2: 16.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__paint2_linear",
    x1: 19.669,
    y1: 17.874,
    x2: 1.978,
    y2: 35.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__paint3_linear",
    x1: 6.059,
    y1: 0.68,
    x2: 13.959,
    y2: 8.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "google-play_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h105.6v32H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/google-play.e17dd44b.svg";
export { SvgGooglePlay as ReactComponent };